import { JSEncrypt } from 'jsencrypt';
import * as AuthUtils from '@Services/Auth/AuthUtils';

export function encrypt(value, pubKey) {
  const encrypter = new JSEncrypt();
  encrypter.setPublicKey(pubKey);
  return encrypter.encrypt(value);
}

export async function encryptUsernameAndPassword(payload) {
  const { username, password } = payload;
  let encryptedUsername;
  let encryptedPassword;

  if (!username && !password) {
    return payload;
  }

  const { rs_token: pubKey } = await AuthUtils.getClientInfo();

  if (!pubKey) {
    return payload;
  }

  if (username) {
    encryptedUsername = encrypt(username, pubKey);
  }

  if (password) {
    encryptedPassword = encrypt(password, pubKey);
  }

  return {
    ...payload,
    ...(encryptedUsername && { username: encryptedUsername }),
    ...(encryptedPassword && { password: encryptedPassword }),
  };
}
